import { combineReducers } from 'redux'

import { reducer as addToExistingModal } from './State/addToExistingModal'

export default combineReducers({
  addToExistingModal,
})
